import * as actions from '../actionTypes'

export const initialDebtInformation = {
  fileNumber: '',
  isVehicleTaxDebt: false,
  // socialInsuranceNumber: '',
  paymentAmount: ''
}

export const initialContactInformation = {
  fullName: '',
  dateOfBirth: '',
  socialInsuranceNumber: '',
  phoneNumber: '',
  email: '',
}

export const initialPayDebtOnBehalf = {
  fullName: '',
  phoneNumber: '',
  email: ''
}

export const initialMailingAddress = {
  streetAddress: '',
  city: '',
  apartment: '',
  postalCode: '',
  country: '',
  provinceOrState: '',
  specify: ''
}

const initialState = {
  debtInformation: { ...initialDebtInformation },
  debtInformationList: [],
  editDebtInfoId: '',

  payeeContactInformation: null,
  contactInformation: { ...initialContactInformation },

  mailingAddress: { ...initialMailingAddress, isMailingAddress: true, }
}

const AppReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.CHANGE_OBJECT_PROPERTY: {
      return {
        ...state,
        [action.payload.object]: {
          ...state[action.payload.object],
          [action.payload.field]: action.payload.value
        }
      }
    }
    case actions.SET_PAY_DEBT_ON_BEHALF:
      return {
        ...state,
        payeeContactInformation: action.payload ? initialPayDebtOnBehalf : null
      }
    case actions.LIST_ADD:
      return addToList(state, action.payload.listType, action.payload.data)
    case actions.LIST_EDIT:
      return editList(state, action.payload.listType, action.payload.data)
    case actions.LIST_DELETE:
      return deletelist(state, action.payload.listType, action.payload.data)
    case actions.EDIT_DEBT_INFO:
      const found = state.debtInformationList.find((debtInfo) => debtInfo.fileNumber === action.payload.value)
      return {
        ...state,
        debtInformation: found ?? { ...initialDebtInformation },
        editDebtInfoId: found ? action.payload.value : ''
      }
    case actions.CLEAR_DEBT_INFO:
      return {
        ...state,
        debtInformation: initialDebtInformation
      }
    case actions.CLEAR_LAST_DEBT:
      return {...state, debtInformationList: state.debtInformationList.slice(0, -1)} 
    case actions.LIST_CLEAR:
      return clearListItem(state, action.payload.listType);
    case actions.CLEAR_ALL:
      return initialState
    default: {
      return state
    }
  }
}
export default AppReducer

/**
 * Adds the new debt information to the debtInformationList array
 * @param {Object} state 
 * @param {String} listType 
 * @param {Object} data 
 * @returns {Object} new state of reducer for adding debt info to list
 */
const addToList = (state, listType, data) => {
  if (listType === 'debtInfo') {
    const foundDup = state.debtInformationList.find(debtInfo => data.fileNumber === debtInfo.fileNumber)
    const debtInformationList = foundDup ? state.debtInformationList : [...state.debtInformationList, data]
    return {
      ...state,
      debtInformationList
    }
  }

  return state;
}

/**
 * 
 * @param {Ojbect} state 
 * @param {string} listType 
 * @param {Object} data 
 * @returns 
 */
const editList = (state, listType, data) => {
  if (listType === 'debtInfo') {
    const debtInformationList = state.debtInformationList.map(debtInfo =>
      state.editDebtInfoId === debtInfo.fileNumber ? data : debtInfo
    );
    return {
      ...state,
      debtInformationList
    }
  }

  return state;
}

/**
 * 
 * @param {Ojbect} state 
 * @param {string} listType 
 * @param {Object} data 
 * @returns 
 */
const deletelist = (state, listType, data) => {
  if (listType === 'debtInfo') {
    const debtInformationList = state.debtInformationList.filter(debtInfo =>
      data !== debtInfo.fileNumber
    );
    return {
      ...state,
      debtInformationList
    }
  }

  return state;
}

const clearListItem = (state, listType) => {
  if (listType === 'debtInfo') {
    return {
      ...state,
      editDebtInfoId: '',//state.debtInformation?.fileNumber ?? '',
      debtInformation: { ...initialDebtInformation },
      debtInformationList: []
    }
  }

  return state;
}